/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseMutationModel,
  IMutationModelOpts,
  useGqlClient,
} from '@r-client/shared/data/client';
import { useLocalObservable } from 'mobx-react-lite';
import {
  ICreateRsvpMutation,
  CreateRsvpDocument,
  ICreateRsvpMutationVariables,
} from './types';
import { IEventsGuestRsvpCreatePayload } from '@r-client/data/graphql-types';
export type { IEventsGuestRsvpCreatePayload };

export class CreateRsvpMutation extends BaseMutationModel<
  ICreateRsvpMutation,
  ICreateRsvpMutationVariables
> {
  get mutation() {
    return CreateRsvpDocument;
  }
}
export function useCreateRsvpMutation(
  opts?: Omit<IMutationModelOpts<ICreateRsvpMutationVariables>, 'client'>
) {
  const client = useGqlClient();
  return useLocalObservable(() => new CreateRsvpMutation({ ...opts, client }));
}
